"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const NotiButton_1 = __importDefault(require("../../../../components/button/NotiButton"));
const ItemNotiTweet = (props) => {
    const { notifications, onSelect, isVis } = props;
    const [heightChild, setHeightChild] = (0, react_1.useState)([]);
    const [isVisible, setVisible] = (0, react_1.useState)(true);
    const [listNoti, setListNoti] = (0, react_1.useState)(notifications);
    (0, react_1.useEffect)(() => {
        if (notifications) {
            setListNoti(notifications);
            setHeightChild([]);
        }
    }, [notifications]);
    (0, react_1.useEffect)(() => {
        if (isVis || isVis == false) {
            setVisible(isVis);
        }
    }, [isVis]);
    const ReadNoti = (data) => {
        let list = [...listNoti];
        let hieght = heightChild?.slice(0, -1);
        list = list.filter((item) => item?._id != data);
        setListNoti(list);
        setHeightChild(hieght);
    };
    const handleLayout = (index) => (event) => {
        const { height } = event.nativeEvent.layout;
        setHeightChild((prevHeights) => {
            const newHeights = [...prevHeights];
            newHeights[index] =
                height + newHeights?.slice(index - 1, index).reduce((acc, h) => acc + h, 0);
            return newHeights;
        });
    };
    return (react_1.default.createElement(react_native_1.View, { style: {
            height: !isVisible ? heightChild[heightChild.length] : heightChild[0],
        } }, listNoti?.map((notification, index) => (react_1.default.createElement(react_native_1.View, { onLayout: handleLayout(index), key: notification?._id || index },
        react_1.default.createElement(react_native_1.TouchableOpacity, { key: notification._id || index, onPress: () => {
                if (onSelect()) {
                    onSelect();
                }
                setVisible(!isVisible);
            } },
            react_1.default.createElement(NotiButton_1.default, { data: notification, isVisible: isVisible, heightViewOne: heightChild[0], height: heightChild[index], index: index, length: listNoti?.length, ReadNoti: (data) => ReadNoti(data) })))))));
};
exports.default = ItemNotiTweet;
